import { Injectable, signal } from '@angular/core'

export type ToastType = 'error' | 'success' | 'warning'

export interface Toast {
  id: number
  type: ToastType
  message: string
}

const AUTO_DISMISS_MS = 4000

/**
 * Lightweight in-house toast notifications (no external UI library).
 * Render `<app-toast-tray />` once, anywhere in the app shell, to display them.
 */
@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  #nextId = 0
  #toasts = signal<Toast[]>([])
  toasts = this.#toasts.asReadonly()

  error(message: string): void {
    this.#push('error', message)
  }

  success(message: string): void {
    this.#push('success', message)
  }

  warning(message: string): void {
    this.#push('warning', message)
  }

  dismiss(id: number): void {
    this.#toasts.update(toasts => toasts.filter(toast => toast.id !== id))
  }

  #push(type: ToastType, message: string): void {
    const id = this.#nextId++
    this.#toasts.update(toasts => [...toasts, { id, type, message }])

    setTimeout(() => this.dismiss(id), AUTO_DISMISS_MS)
  }
}
